import {getMedicalOrderDetail, listMedicalOrder, getDicts, getPatientListByName} from "@/api";
import {addDateRange, message, getCurrentDoctorId} from "@/assets/utils/common";
import baseConfig from "@/api/config";
import html2canvas from 'html2canvas'
import Orderdetail from "@/components/orderdetail.vue";
import {getDecoctionName, refreshDecoctionNameMap} from "@/assets/utils/decoction";

export default {
    components: {Orderdetail},
    data() {
        return {
            currentPageOrder: 1,
            pageNumsOrder: 20,
            totalCountOrder: 0,
            queryOrderParams: {
                serialNo: '',
                status: '',
                billingType: '',
                identity: '',
                phoneNumber: '',
                patientName: '',
                params: null
            },
            patientRange: [],
            nameSelectConShow: false,
            patientNameSearchTimer: null,
            orderTableLoading: false,
            dateTime: null,
            dateOrderTime: '',
            orderTableHeight: 500,
            tencentCosUrl: baseConfig.tencentCosUrl,
            patientInfo: {
                avatarImg: null,
                name: null,
                sex: null,
                age: null,
                phoneNumber: null,
                identity: null,
                province: null,
                dppId: null,
                height: null,
                weight: null,
                casePic: null,
                operationHistory: null,
                medicalHistory: null
            },
            orderlist: [],
            patientId: null,
            direction: 'rtl',
            orderDetailDialogVisible: false,

            orderId: null,
            orderWarningInfo: null,
            fileLists: [],
            imageStyles: {
                width: 90,
                height: 120,
            },
            medicalOrder: {
                orderSource: null,
                status: null,
                serialNo: null,
                medicineType: null,
                picUrl: null,
                orderWeight: null,
                payQrcode: null,
                createTime: null,
                updateTime: null,
                pharmacyName: null,
                pharmacistName: null,
                remark: null,
                pharmacyAddress: null,
                clinicalDiagnosis: null,
                orderMedicineList: [],
                orderMedicineFuList: [],
                instructions: null,
                orderPrice: 0,
                payTime: null,
                viceNum: 0,
                deliverTime: null,
                freeCasePic: null,
                processingCosts: null,
            },
            showOrderMedicineFuList: "", // 辅料药材信息
            dictOrderStatus:'sys_order_status',
            dictOrderStatusList:[],
            doctorInfo: {
                name: null,
                signPic: null,
                phoneNumber: null,
                docPriceHide: 0, // 诊费 0 显示  1 隐藏
            },
            prescriptionPaperDialogDialogVisible: false, // 处方笺预览弹窗
            printDate: null, // 打印日期
        }
    },
    mounted() {
        //此处需要通过延迟方法来设置值，不然会出现值已更新，但页面没更新的问题
        setTimeout(() => {
            this.orderTableHeight = window.innerHeight - this.$refs.multipleOrderTable.$el.offsetTop - 80;
        }, 100)
    },
    created() {
        refreshDecoctionNameMap();
        getDicts(this.dictOrderStatus).then(res => {
            this.dictOrderStatusList  = res.data.data;
        });
        this.getOrderList();
    },
    methods: {
        queryPatientListByName(queryName) {
            window.clearTimeout(this.patientNameSearchTimer);
            if (queryName === "" || queryName === null || queryName === undefined) {
                this.patientRange = [];
                this.nameSelectConShow = false;
                return;
            }
            this.patientNameSearchTimer = window.setTimeout(() => {
                getPatientListByName({name: queryName, docId: getCurrentDoctorId()}).then(response => {
                    const rows = response.data && response.data.code === 200 ? response.data.rows || [] : [];
                    this.patientRange = rows.map(item => ({
                        dppId: item.dppId,
                        name: item.name,
                        sex: item.sex === '0' ? '男' : item.sex === '1' ? '女' : '未知',
                        age: item.age === null || item.age === undefined ? '--' : item.age,
                        isChoose: item.name === this.queryOrderParams.patientName
                    }));
                    this.nameSelectConShow = this.patientRange.length > 0;
                }).catch(() => {
                    this.patientRange = [];
                    this.nameSelectConShow = false;
                });
            }, 300);
        },

        choosePatientName(name) {
            this.queryOrderParams.patientName = name;
            this.patientRange = this.patientRange.map(item => ({...item, isChoose: item.name === name}));
            this.nameSelectConShow = false;
        },

        handlePatientNameBlur() {
            window.setTimeout(() => {
                this.nameSelectConShow = false;
            }, 200);
        },

        changeData(name) {
            this.$router.push({path: '/admin/' + name});
            this.$store.state.adminleftnavnum = name; //设置左侧导航2-2 active
        },

        // chooseDateTime
        chooseDateTime() {
            addDateRange(this.queryOrderParams, this.dateTime);
        },

        // 切换分页
        handleOrderCurrentChange: function (val) {
            this.currentPageOrder = val;
            this.getOrderList();
        },

        // 切换分页
        handleOrderSizeChange: function (val) {
            this.pageNumsOrder = val;
            this.getOrderList();
        },

        /** 重置按钮操作 */
        resetQuery() {
            this.dateTime = [];
            this.queryOrderParams = {
                serialNo: '',
                status: '',
                billingType: '',
                identity: '',
                phoneNumber: '',
                patientName: '',
                params: null
            };
            addDateRange(this.queryOrderParams, this.dateTime);
            this.getOrderList();
        },

        // 查询订单列表
        getOrderList() {
            this.orderlist = [];
            this.orderTableLoading = true;
            //根据工单类型筛选，已完成订单
            this.queryOrderParams.pageNum = this.currentPageOrder;
            this.queryOrderParams.pageSize = this.pageNumsOrder;
            listMedicalOrder(this.queryOrderParams).then(response => {
                // console.log(response);
                this.orderTableLoading = false;
                if (response.data.code === 200) {
                    this.totalCountOrder = response.data.total;
                    if (response.data.total > 0) {
                        this.orderlist = response.data.rows;
                        this.orderlist.forEach((medicalOrder) => {
                            if (medicalOrder.patientSex === '0') {
                                medicalOrder.patientSexText = '男';
                                medicalOrder.patientAvatar = this.tencentCosUrl + "/tcmmsPic/manImg.png";
                            } else if (medicalOrder.patientSex === '1') {
                                medicalOrder.patientSexText = '女';
                                medicalOrder.patientAvatar = this.tencentCosUrl + "/tcmmsPic/womanImg.png";
                            } else {
                                medicalOrder.patientSexText = '未知';
                                medicalOrder.patientAvatar = this.tencentCosUrl + "/tcmmsPic/profile.jpg";
                            }

                            if (medicalOrder.billingType === "0") {
                                medicalOrder.billingTypeName = "颗粒";
                            } else if (medicalOrder.billingType === "1") {
                                medicalOrder.billingTypeName = "饮片";
                            } else if (medicalOrder.billingType === "2") {
                                medicalOrder.billingTypeName = "膏方";
                            } else if (medicalOrder.billingType === "3") {
                                medicalOrder.billingTypeName = "水丸";
                            }

                            medicalOrder.showOrderMedicineInfo = "";
                            if (medicalOrder.orderMedicineList.length > 0) {
                                medicalOrder.orderMedicineList.forEach((med) => {
                                    let meName = med.meName;
                                    if (meName !== null && meName !== undefined) {
                                        meName = meName.replace('配方', '').replace('颗粒', '').replace('饮片', '');
                                    }
                                    med.meName = meName;
                                    medicalOrder.showOrderMedicineInfo += med.meName + "" + med.countNum + "g,";
                                });
                            }
                            if (medicalOrder.orderMedicineFuList.length > 0) {
                                medicalOrder.showOrderMedicineInfo += "辅药(";
                                medicalOrder.orderMedicineFuList.forEach((med) => {
                                    let meName = med.meName;
                                    if (meName !== null && meName !== undefined) {
                                        meName = meName.replace('配方', '').replace('颗粒', '').replace('饮片', '');
                                    }
                                    med.meName = meName;
                                    medicalOrder.showOrderMedicineInfo += med.meName + "" + med.countNum + "g,";
                                });
                                medicalOrder.showOrderMedicineInfo = medicalOrder.showOrderMedicineInfo.substring(0, medicalOrder.showOrderMedicineInfo.length - 1);
                                medicalOrder.showOrderMedicineInfo += ')';
                            } else {
                                medicalOrder.showOrderMedicineInfo = medicalOrder.showOrderMedicineInfo.substring(0, medicalOrder.showOrderMedicineInfo.length - 1);
                            }
                        })
                    }
                }
            });
        },


        getOrderStatus(dictCode){
            return this.getDictValue(dictCode,this.dictOrderStatusList);
        },

        getDictValue(dictKey, dictList) {
            let str = '';
            dictList.forEach(e => {
                if (e.dictValue == dictKey) {
                    str = e.dictLabel;
                }
            })
            return str;
        },
        // 打开订单详情
        dbclickOpenOrderDetail(row) {
            let orderId = row.orderId;
            let status = row.status;
            this.openOrderDetail(orderId, status);
        },

        // 打开订单详情
        openOrderDetail(orderId, status) {
            this.orderId = orderId;
            if (status === '1') {
                message("药方审核中，请耐心等待...", "error");
            } else if (status === '2') {
                message("药方转方中，请耐心等待...", "error");
            } else {
                this.orderDetailDialogVisible = true;
                this.queryOrderDetail();
                // this.$router.push({path: '/admin/detail', query: { orderId: orderId }});
                // this.$store.state.adminleftnavnum = 'detail'; //设置左侧导航2-2 active
            }
        },


        // 查询订单详情
        queryOrderDetail() {
            getMedicalOrderDetail(this.orderId).then(response => {
                console.log("getMedicalOrderDetailInfo response");
                console.log(response);
                let rdata = response.data.data;
                this.medicalOrder = rdata.medicalOrder;
                this.medicalOrder.orderPrice = parseFloat(rdata.medicalOrder.orderPrice).toFixed(2);
                this.medicalOrder.processingCosts = parseFloat(rdata.medicalOrder.processingCosts).toFixed(2);

                this.medicalOrder.docTotalPrice = parseFloat(this.medicalOrder.medicalCountPrice * 0.3 +
                    this.medicalOrder.docPrice + this.medicalOrder.adjustmentPrice).toFixed(2);
                if (this.medicalOrder.picUrl !== null && this.medicalOrder.picUrl !== "") {
                    this.medicalOrder.picUrl = this.tencentCosUrl + this.medicalOrder.picUrl;
                    this.fileLists.push({
                        url: this.medicalOrder.picUrl,
                    });
                }
                if (this.medicalOrder.orderMedicineList !== null && this.medicalOrder.orderMedicineList !== "") {
                    for (let m = 0; m < this.medicalOrder.orderMedicineList.length; m++) {
                        let melist = this.medicalOrder.orderMedicineList[m];
                        let meName = melist.meName;
                        if (meName !== null && meName !== undefined) {
                            meName = meName.replace('配方', '').replace('颗粒', '').replace('饮片', '');
                        }
                        melist.meName = meName;
                        let decoctWay = melist.decoctWay;
                        let decoctionName = getDecoctionName(decoctWay);
                        melist.decoctionId = decoctWay;
                        melist.decoctionName = decoctionName;
                    }

                }

                if (this.medicalOrder.orderMedicineFuList !== null && this.medicalOrder.orderMedicineFuList !== "") {
                    for (let n = 0; n < this.medicalOrder.orderMedicineFuList.length; n++) {
                        let meName = this.medicalOrder.orderMedicineFuList[n].meName;
                        if (meName !== null && meName !== undefined) {
                            meName = meName.replace('配方', '').replace('颗粒', '').replace('饮片', '').replace('辅药', '');
                        }
                        this.medicalOrder.orderMedicineFuList[n].meName = meName;
                    }
                }
                this.medicalCountPrice = parseFloat(parseFloat(this.medicalOrder.medicalCountPrice) + parseFloat(this.medicalOrder.fuCountPrice)).toFixed(2);

                this.showOrderMedicineFuList = "";
                if (this.medicalOrder.orderMedicineFuList !== null && this.medicalOrder.orderMedicineFuList !== "") {
                    this.medicalOrder.orderMedicineFuList.forEach((med) => {
                        let meName = med.meName;
                        if (meName !== null && meName !== undefined) {
                            meName = meName.replace('配方', '').replace('颗粒', '').replace('饮片', '');
                        }
                        med.meName = meName;
                        this.showOrderMedicineFuList += med.meName + "(" + med.countNum + "g),";
                    });
                    this.showOrderMedicineFuList = this.showOrderMedicineFuList.substring(0, this.showOrderMedicineFuList.length - 1);
                }

                this.doctorInfo = rdata.doctorInfo;
                if (rdata.userReceiveAddress !== null && rdata.userReceiveAddress !== "" &&
                    rdata.userReceiveAddress !== undefined) {
                    this.userReceiveAddress = rdata.userReceiveAddress;
                }
                this.patientInfo = rdata.patientInfo;

                if (this.patientInfo.sex === '0') {
                    this.patientInfo.avatarImg = this.tencentCosUrl + "/tcmmsPic/manImg.png";
                } else if (this.patientInfo.sex === '1') {
                    this.patientInfo.avatarImg = this.tencentCosUrl + "/tcmmsPic/womanImg.png";
                } else {
                    this.patientInfo.avatarImg = this.tencentCosUrl + "/tcmmsPic/profile.jpg";
                }
                if (this.medicalOrder.orderSource !== 'patient' && this.medicalOrder.orderSource !== 'patientRepeat') {
                    // this.getPayErCode(rdata.medicalOrder.payQrcode);
                }

                let freeCasePic = this.medicalOrder.freeCasePic;
                console.log(freeCasePic)
                if (freeCasePic !== null && freeCasePic !== "") {
                    let freeCasePicArray = freeCasePic.split(",");
                    if (freeCasePicArray.length > 0) {
                        this.freeCasePicArr = [];
                        for (let i = 0; i < freeCasePicArray.length; i++) {
                            let freeImgUrl = this.tencentCosUrl + freeCasePicArray[i];
                            console.log(freeImgUrl);
                            this.freeCasePicArr.push(freeImgUrl);
                        }

                    }
                }

            });

        },



        // 打开处方笺
        exportOrder() {
            this.prescriptionPaperDialogDialogVisible = true;
            this.printDate = this.getDayDateNow();
        },

        handlePrint(){
            // 获取要转换为图片的 DOM 元素
            const element = document.querySelector('.prescriptionPaperDialog');
            // 将 DOM 元素转换为 Canvas 对象
            html2canvas(element,{
                dpi: window.devicePixelRatio * 2,
                useCORS: true,
                allowTaint: true,
                async: true,
            }).then(canvas => {
                // 创建一个新的图片元素，并将 Canvas 对象作为背景图
                const img = new Image();
                img.src = canvas.toDataURL('image/png');
                img.style.width='100%'
                // 在 iframe 文档中添加图片元素
                const iframe = document.createElement('iframe');
                iframe.style.width='100%'
                iframe.classList.add('print-iframe')
                document.body.appendChild(iframe)
                const doc = iframe.contentWindow.document
                doc.body.appendChild(img);
                //避免图片没有加载完成就打印
                setTimeout(()=>{
                    iframe.contentWindow.print();
                },100)

            }, {
                useCORS: true,
                allowTaint: false,
                logging: false,
                letterRendering: true,
            })
        },


        // 获取当前时间
        getDayDateNow() {
            let nowDate = new Date();
            let year = nowDate.getFullYear();
            let month = this.checkTime(nowDate.getMonth() + 1);
            let date = this.checkTime(nowDate.getDate());
            let hour = this.checkTime(nowDate.getHours());
            let minute = this.checkTime(nowDate.getMinutes());
            let second = this.checkTime(nowDate.getSeconds());
            return year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second;
        },

        checkTime(a) {
            if (a < 10) {
                a = "0" + a;
            }
            return a;
        },

    }
}